// react components
import React, {
    useRef,
} from 'react'
import {
    Dialog,
} from '@mui/material'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModalMainFormHideSite,
} from 'data'

// pages
import {
    FormModal825,
} from 'pages'

// main
export const MainFormModalWrapper825: React.FC = () => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const formModalRef = useRef<{ onCloseModal: (value?: any, forceClose?: boolean) => void }>(null)

    const contentType = reduxModalSite.mainForm.contentType
    const contentTypeSettings = reduxModalSite.mainForm.contentTypeSettings
    const defaultFields = reduxModalSite.mainForm.defaultFields
    const isOpen = reduxModalSite.mainForm.isOpen
    const objectId = reduxModalSite.mainForm.objectId
    const onRefresh = reduxModalSite.mainForm.onRefresh
    const profileObject = reduxModalSite.mainForm.profileObject
    const setDeleted = reduxModalSite.mainForm.setDeleted
    const subContentTypeForced = reduxModalSite.mainForm.subContentTypeForced

    const handleBackdropClick = () => {
        if (formModalRef.current) {
            formModalRef.current.onCloseModal()
        } else {
            dispatch(reduxModalMainFormHideSite())
        }
    }

    return (
        <Dialog
            className='form-container-modal-825'
            classes={{ paper: 'mo-dialog-wrapper' }}
            disableEnforceFocus
            maxWidth='xl'
            onClose={handleBackdropClick}
            open={isOpen}
        >
            {contentType && (
                <FormModal825
                    ref={formModalRef}
                    contentType={contentType}
                    contentTypeSettingsN={contentTypeSettings}
                    defaultFields={defaultFields}
                    // @ts-ignore
                    objectId={objectId}
                    onRefresh={onRefresh}
                    profileObject={profileObject}
                    setDeleted={setDeleted}
                    subContentTypeForced={subContentTypeForced}
                />
            )}
        </Dialog>
    )
}
